import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { PREDIKAT_STYLES } from 'app/KinerjaShared/components/PredikatBadge'
import { PREDIKAT_KINERJA_LABEL } from 'app/KinerjaShared/constants/penetapanPredikatKinerja'

import type { TPredicateRecommendationResult } from 'types/kinerja-pelaksanaan'

type PredikatLabelProps = {
  value: TPredicateRecommendationResult | null
  defaultLabel?: string
}

export function PredikatLabel({
  value,
  defaultLabel = '-',
}: PredikatLabelProps) {
  const label = PREDIKAT_KINERJA_LABEL[value]

  return (
    <div
      className={clsx([
        'px-6 py-4',
        'rounded-lg border text-center',
        label ? 'border-transparent' : 'border-subdued',
        PREDIKAT_STYLES[value] || 'bg-gray-10',
      ])}
    >
      <Text variant="body-bold" as="span">
        {label || defaultLabel}
      </Text>
    </div>
  )
}
